
import React, { useState, useEffect } from 'react';
import {
  CreditCard, Users, Globe, TrendingUp,
  Award, CheckCircle, ArrowRight, Smartphone, Database, Lock, Building2,
  Wallet, FileCheck, Calculator, Shield, UserCheck,
  FileText, Camera, Mail, Store, GraduationCap, Wifi, Zap, Server, Eye, Sparkles
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const PaymentSolutionsLanding = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

    const [modalOpen, setModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [modalTitle, setModalTitle] = useState('');

  const openModal = (image, title) => {
    setModalImage(image);
    setModalTitle(title);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalImage('');
    setModalTitle('');
  };

const services = [
{
  id: 1,
  title: "Chargeback Management",
  description: "Our system works closely with banking partners to handle chargeback requests promptly and fairly, ensuring both merchants and customers are heard.",
  image: "./istock.jpg"
},
    {
      id: 2,
      title: "TDR & MDR Management",
      description: "Setup MDR for various Payment Methods at Acquirer TID/MID level with ease. Configure TDR and Acquire MDR for Merchants at Payment Method level.",
      image: "./mdr.png"
    },
    {
      id: 3,
      title: "Split Settlements",
      description: "Split the Payment made by user. Distribute the funds received between Merchant and his Vendors/Partners/Subsidiaries.",
      image: "./split.jpg"
    },
    {
      id: 4,
      title: "Fraud Checks",
      description: "A number of checks are made before transaction is flagged as probably fraudulent. Velocity Checks, Blacklist, High-value Transactions.",
      image: "./fraud.png"
    },
    {
      id: 5,
      title: "Analytics & Reporting",
      description: "Comprehensive analytics dashboard with real-time reporting. Track transaction volumes, success rates, and revenue metrics with detailed insights.",
      image: "./analytics.png"
    },
    {
      id: 6,
      title: "Security & Compliance",
      description: "Bank-grade with major security compliant. Advanced encryption, tokenization, and secure payment processing to protect sensitive data.",
      image: "./security.jpg"
    }
  ];

 
  const features = [
    { icon: Shield, text: "VAPT Certified" },
    { icon: Lock, text: "Advanced RSA Encryption" },
    { icon: CheckCircle, text: "24/7 Security Monitoring" },
    { icon: Server, text: "Enterprise Infrastructure" }
  ];

  const verificationSteps = [
    {
      icon: FileText,
      title: "GSTN VERIFICATION",
      description: "Verify legal name of Business, Business Address with GST Network",
      color: "from-orange-400 to-red-500"
    },
    {
      icon: Camera,
      title: "ID VERIFICATION VIA SELFIE",
      description: "Verify PAN/E Image on card Issued ID with Live Selfie",
      color: "from-red-400 to-pink-500"
    },
    {
      icon: Smartphone,
      title: "MOBILE VERIFICATION",
      description: "Verify Mobile number Owner if it belongs to the Merchant via OTP",
      color: "from-purple-400 to-indigo-500"
    },
    {
      icon: Mail,
      title: "EMAIL VERIFICATION",
      description: "Verify Email address Owner if it belongs to the Merchant via OTP",
      color: "from-pink-400 to-purple-500"
    },
    {
      icon: CreditCard,
      title: "PAN VERIFICATION",
      description: "Enter PAN Number, full name, date of birth to verify if the details shared are right",
      color: "from-green-400 to-teal-500"
    },
    {
      icon: Building2,
      title: "BANK ACCOUNT VERIFICATION",
      description: "Verify if the given Bank Account Exists. Match name provided against the name registered with Bank",
      color: "from-blue-400 to-cyan-500"
    }
  ];




  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header Section */}
      <Header />
  {/* SECTION 1: DARK - Hero Section */}
       <section className="relative py-16 overflow-hidden min-h-[80vh] flex items-center bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900">
  {/* Animated Dotted Circles Background */}
  <div className="absolute inset-0">
    <div 
      className="absolute top-10 left-10 w-96 h-96 rounded-full border-2 border-dotted border-blue-400/30"
      style={{
        animation: 'spin 20s linear infinite'
      }}
    ></div>
    <div 
      className="absolute top-20 left-20 w-80 h-80 rounded-full border-2 border-dotted border-red-400/40"
      style={{
        animation: 'spin 15s linear infinite reverse'
      }}
    ></div>
    <div 
      className="absolute top-32 left-32 w-64 h-64 rounded-full border border-dotted border-blue-300/25"
      style={{
        animation: 'spin 25s linear infinite'
      }}
    ></div>
    <div 
      className="absolute bottom-10 right-10 w-96 h-96 rounded-full border-2 border-dotted border-purple-400/30"
      style={{
        animation: 'spin 18s linear infinite reverse'
      }}
    ></div>
    <div 
      className="absolute bottom-20 right-20 w-80 h-80 rounded-full border-2 border-dotted border-red-400/35"
      style={{
        animation: 'spin 22s linear infinite'
      }}
    ></div>
    <div 
      className="absolute bottom-32 right-32 w-64 h-64 rounded-full border border-dotted border-blue-300/20"
      style={{
        animation: 'spin 16s linear infinite reverse'
      }}
    ></div>
    <div 
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full border-2 border-dotted border-cyan-400/25"
      style={{
        animation: 'spin 30s linear infinite'
      }}
    ></div>
    <div 
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 rounded-full border border-dotted border-red-400/30"
      style={{
        animation: 'spin 12s linear infinite reverse'
      }}
    ></div>
  </div>

  <div className="relative z-10 px-6 max-w-7xl mx-auto w-full">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      <div className="text-center lg:text-left">
        <div className="mb-6">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-3 rounded-full text-sm font-bold mb-4 shadow-xl">
            #1 Payment Solution
          </div>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Business Payments,
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">
            With UPI
          </span>
        </h1>

        <div className="border-2 border-white/40 rounded-lg p-4 mb-8 inline-block">
          <p className="text-xl md:text-2xl text-white font-light leading-relaxed">
            All in one Cloud Software Suite for seamless payment processing
          </p>
        </div>

        <div className="mb-8">
          <p className="text-lg text-blue-100 mb-6">
            Just for you and no one else.
          </p>
        </div>
      </div>

      <div className="relative flex items-center justify-center">
        <div className="relative">
          <div 
            className="absolute inset-0 w-80 h-80 rounded-full border-4 border-dotted border-red-400/60"
            style={{
              animation: 'spin 20s linear infinite'
            }}
          ></div>
          <div 
            className="absolute inset-4 w-72 h-72 rounded-full border-2 border-dotted border-blue-400/40"
            style={{
              animation: 'spin 15s linear infinite reverse'
            }}
          ></div>
          
          <div className="relative w-80 h-80 flex items-center justify-center">
            <div className="w-48 h-64 bg-gradient-to-br from-gray-100 to-gray-300 rounded-3xl shadow-2xl flex items-center justify-center transform rotate-12 hover:rotate-0 transition-transform duration-500 overflow-hidden">
              <img 
                src="./India-UPI.PNG" 
                alt="UPI Payment" 
                className="w-full h-full object-cover rounded-3xl"
              />
            </div>
          </div>
        </div>

        <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm rounded-lg p-3 shadow-xl">
          <div className="text-center">
            <div className="text-xs font-bold text-gray-700 mb-1">ASSOCIATE PARTNER</div>
            <div className="text-lg font-bold text-blue-600">TechPay</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

        {/* SECTION 2: LIGHT - Our Offerings */}
        <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
          <div className="container mx-auto px-6">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
              OUR OFFERINGS
            </h2>

            <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
              {/* Payments Technology */}
              <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="text-center mb-6">
                  <div className="bg-gradient-to-r from-blue-500 to-purple-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <CreditCard className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">PAYMENTS TECHNOLOGY</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  A flexible, deeply trust-based platform that enables you to accept payments from a
                  wide variety of payment methods. Make payments to your vendors/partners
                  without switching to extra portals. Our pre-built integrations
                  enable you to connect with your recipients instantly.
                </p>
              </div>

              {/* Recon & Settlements */}
              <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="text-center mb-6">
                  <div className="bg-gradient-to-r from-green-500 to-blue-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <TrendingUp className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">RECON & SETTLEMENTS</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Reconcile successful transaction reports from acquirers in a few simple steps. Settle
                  only the transactions you want to. Settle automatically without human intervention,
                  handle funds, dispute and manage disputes with ease. Handle settlement vouchers
                  internally and avoid outside settlements.
                </p>
              </div>

              {/* Merchant Management */}
              <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="text-center mb-6">
                  <div className="bg-gradient-to-r from-purple-500 to-pink-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <Users className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">MERCHANT MANAGEMENT</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Onboard merchants by integrating with our system. Tier 3B Digital Service certification
                  for KYC services, secure online agreements. Merchants can start transacting from
                  Day One. Manage split ratio flows too. Our Plug n Play Architecture enables you to
                  handle Merchant transactions with a click.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: DARK - Payment Methods */}
        <section className="py-16 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-bold text-center mb-12 text-white">
              PAYMENT METHODS
            </h2>

            <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
              {/* Cards */}
              <div className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <div className="bg-gradient-to-r from-blue-500 to-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CreditCard className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">CARDS</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  A Payment Network like VISA, MASTER that accepts Credit and Debit Cards to process payments
                </p>
              </div>

              {/* UPI */}
              <div className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <div className="bg-gradient-to-r from-orange-500 to-red-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Smartphone className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">UPI</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  An Instant Payment Service where users can transfer funds between any two Bank Accounts using UPI ID
                </p>
              </div>

              {/* Net Banking */}
              <div className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <div className="bg-gradient-to-r from-green-500 to-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Building2 className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">NETBANKING</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  An electronic payment service that enables users to make payments from their Bank Accounts
                </p>
              </div>
            </div>

            {/* Second Row */}
            <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-8 mt-8">
              {/* Wallet */}
              <div className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <div className="bg-gradient-to-r from-purple-500 to-pink-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Wallet className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">WALLETS</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Digital wallets for quick and secure payments
                </p>
              </div>

              {/* EMI */}
              <div className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <div className="bg-gradient-to-r from-indigo-500 to-purple-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FileCheck className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">EMI</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Easy monthly installment options for customers
                </p>
              </div>

              {/* POS */}
              <div className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <div className="bg-gradient-to-r from-cyan-500 to-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Calculator className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">POS</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Point of sale solutions for in-store payments
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 4: LIGHT - Technology Innovation */}
        <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <div className="mb-8">
                <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl p-8 inline-block">
                  <Database className="w-16 h-16 text-white mx-auto" />
                </div>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-8 text-gray-800">
                TECHNOLOGY DRIVEN INNOVATION IS CLOSE TO OUR HEART.
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed">
                We leverage cutting-edge technology to provide seamless, secure, and scalable payment solutions
                that empower businesses to grow without limits.
              </p>
            </div>
          </div>
        </section>

        {/* SECTION 5: DARK - Our Services */}
        <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900">
          <div className="container mx-auto px-6">
            <div className="max-w-7xl mx-auto">
              
              {/* Image Modal */}
              {modalOpen && (
                <div 
                  className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
                  onClick={(e) => e.target === e.currentTarget && closeModal()}
                >
                  <div className="relative max-w-4xl max-h-[90vh] w-full">
                    <button 
                      onClick={closeModal}
                      className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-10"
                    >
                      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                    <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
                      <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-purple-50">
                        <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">{modalTitle}</h3>
                      </div>
                      <div className="p-8 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
                        <img 
                          src={modalImage} 
                          alt={modalTitle} 
                          className="max-w-full max-h-[60vh] object-contain rounded-lg shadow-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              {/* Header */}
              <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Our Services
                </h2>
                <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                  Comprehensive payment management solutions designed for modern businesses
                </p>
              </div>

              {/* Services Grid */}
              <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">
                {services.map((service) => (
                  <div key={service.id} className="group">
                    <div className="bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 hover:bg-white/20 hover:shadow-2xl transition-all duration-500">
                      
                      {/* Service Image */}
                      <div 
                        className="relative h-56 bg-gradient-to-br from-gray-800 to-gray-900 p-4 flex items-center justify-center cursor-pointer rounded-t-2xl"
                        onClick={() => openModal(service.image, service.title)}
                      >
                        <img
                          src={service.image}
                          alt={service.title}
                          className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
                        />
                        <div className="absolute top-6 right-6">
                          <div className="w-3 h-3 bg-emerald-500 rounded-full shadow-lg animate-pulse"></div>
                        </div>
                        <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-all duration-300 flex items-center justify-center opacity-0 hover:opacity-100 rounded-t-2xl">
                          <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg">
                            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                            </svg>
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-8">
                        <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400 mb-4">
                          {service.title}
                        </h3>
                        <p className="text-gray-300 leading-relaxed">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </section> 
   {/* Security & Infrastructure Section */}
<section 
      className="py-10 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(30, 41, 59, 0.8)), url('security.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Content Side - Left */}
          <div className={`space-y-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
            <div className="space-y-6">
              <div className="flex items-center space-x-3">
                <div className="bg-blue-500/10 p-3 rounded-lg border border-blue-500/20">
                  <Shield className="w-6 h-6 text-blue-400" />
                </div>
                <span className="text-blue-400 font-medium tracking-wide text-sm uppercase">Enterprise Security</span>
              </div>

              <h2 className="text-4xl lg:text-5xl font-bold leading-tight">
                Bank-Grade Security
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400 mt-1">
                  Infrastructure
                </span>
              </h2>

              <p className="text-lg text-gray-300 leading-relaxed max-w-xl">
                Enterprise-grade security platform with VAPT certification, 
                advanced encryption protocols, and continuous monitoring to protect your critical business data.
              </p>
            </div>
   {/* Feature Grid */}
              <div className="grid grid-cols-2 gap-4">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className={`flex items-center space-x-3 p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 transition-all duration-700 hover:bg-white/10 hover:scale-105 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                    style={{ transitionDelay: `${index * 100}ms` }}
                  >
                    <feature.icon className="w-5 h-5 text-blue-400 flex-shrink-0" />
                    <span className="text-sm font-medium">{feature.text}</span>
                  </div>
                ))}
              </div>
           
          </div>

          {/* Features Grid - Right Side */}
            <div className={`relative transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <div className="relative">
                {/* Main Security Hub */}
                <div className="relative bg-gradient-to-br from-blue-500/20 to-purple-600/20 backdrop-blur-sm rounded-3xl p-8 border border-white/20">

                  {/* Central Lock Icon */}
                  <div className="flex justify-center mb-8">
                    <div className="relative">
                      <div className="w-24 h-24 bg-gradient-to-br from-blue-400 to-purple-500 rounded-2xl flex items-center justify-center animate-pulse">
                        <Lock className="w-12 h-12 text-white" />
                      </div>
                      {/* Rotating Ring */}
                      <div className="absolute inset-0 border-4 border-transparent border-t-blue-400 rounded-2xl animate-spin"></div>
                    </div>
                  </div>

                  {/* Security Nodes */}
                  <div className="relative">
                    {/* Top Node */}
                    <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
                      
                      <div className="absolute top-1/2 left-1/2 w-px h-16 bg-gradient-to-b from-blue-400 to-transparent transform -translate-x-1/2"></div>
                    </div>

                    {/* Left Node */}
                    <div className="absolute top-1/2 -left-12 transform -translate-y-1/2">
                      <div className="w-16 h-16 bg-gradient-to-r from-purple-400 to-pink-500 rounded-xl flex items-center justify-center animate-bounce" style={{ animationDelay: '0.5s' }}>
                        <Server className="w-8 h-8 text-white" />
                      </div>
                      <div className="absolute top-1/2 left-full w-16 h-px bg-gradient-to-r from-purple-400 to-transparent transform -translate-y-1/2"></div>
                    </div>

                    {/* Right Node */}
                    <div className="absolute top-1/2 -right-12 transform -translate-y-1/2">
                      <div className="w-16 h-16 bg-gradient-to-r from-orange-400 to-red-500 rounded-xl flex items-center justify-center animate-bounce" style={{ animationDelay: '1s' }}>
                        <Zap className="w-8 h-8 text-white" />
                      </div>
                      <div className="absolute top-1/2 right-full w-16 h-px bg-gradient-to-l from-orange-400 to-transparent transform -translate-y-1/2"></div>
                    </div>

                    {/* Bottom Node */}
                    <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
                      <div className="w-16 h-16 bg-gradient-to-r from-teal-400 to-green-500 rounded-xl flex items-center justify-center animate-bounce" style={{ animationDelay: '1.5s' }}>
                        <CheckCircle className="w-8 h-8 text-white" />
                      </div>
                      <div className="absolute bottom-full left-1/2 w-px h-16 bg-gradient-to-t from-teal-400 to-transparent transform -translate-x-1/2"></div>
                    </div>
                  </div>

                  {/* Security Stats */}
                  <div className="mt-12 grid grid-cols-3 gap-4 text-center">
                    <div className="space-y-1">
                      <div className="text-2xl font-bold text-blue-400">256-bit</div>
                      <div className="text-xs text-gray-400">Encryption</div>
                    </div>
                    <div className="space-y-1">
                      <div className="text-2xl font-bold text-green-400">24/7</div>
                      <div className="text-xs text-gray-400">Monitoring</div>
                    </div>
                    <div className="space-y-1">
                      <div className="text-2xl font-bold text-purple-400">Level 1</div>
                      <div className="text-xs text-gray-400">Bank Grade Security</div>
                    </div>
                  </div>
                </div>

                {/* Floating Security Badges */}
                <div className="absolute -top-6 -left-6 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-semibold animate-pulse">
                  SOC 2 Compliant
                </div>

                <div className="absolute -bottom-6 -right-6 bg-gradient-to-r from-green-500 to-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold animate-pulse" style={{ animationDelay: '1s' }}>
                  Zero Trust Architecture
                </div>
              </div>

              {/* Background Glow Effects */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-3xl blur-3xl -z-10 animate-pulse"></div>
              <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-blue-500/10 rounded-full blur-2xl animate-ping"></div>
              <div className="absolute bottom-1/4 right-1/4 w-24 h-24 bg-purple-500/10 rounded-full blur-2xl animate-ping" style={{ animationDelay: '2s' }}></div>
            </div>
        </div>
      </div>
    </section>
      {/* White Label Solutions */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">

              {/* Image Side */}
              <div className="order-2 lg:order-1">
                <div className="relative">
                  <img
                    src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                    alt="White Label Payment Solutions"
                    className="w-full h-96 object-cover rounded-2xl shadow-2xl"
                  />
                  {/* Overlay Elements */}
                  <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-4 shadow-lg">
                    <div className="flex items-center space-x-3">
                      <div className="bg-gradient-to-r from-purple-500 to-blue-600 rounded-lg p-2">
                        <Shield className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-gray-800">Secure & Reliable</div>
                        <div className="text-xs text-gray-500">99.9% Uptime</div>
                      </div>
                    </div>
                  </div>

                  <div className="absolute -top-6 -left-6 bg-white rounded-xl p-4 shadow-lg">
                    <div className="flex items-center space-x-3">
                      <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg p-2">
                        <Globe className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-gray-800">National Reach</div>
                        <div className="text-xs text-gray-500">3+ States</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Content Side */}
              <div className="order-1 lg:order-2">
                <div className="mb-6">

                  <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-800 leading-tight">
                    WHITE LABEL SOLUTIONS
                  </h2>
                </div>

                <p className="text-lg text-gray-600 leading-relaxed mb-8">
                  We enable Aggregators, Banks, PSPs, eCommerce companies and Large Businesses launch their
                  own Payment Gateway solutions. Our simple, flexible and scalable solution works for tech-savvy
                  startups as well as larger multi-nationals with the same ease.
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-start space-x-3">
                    <div className="bg-blue-100 rounded-full p-2 mt-1">
                      <Shield className="w-4 h-4 text-blue-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-1">Technology Focus</h4>
                      <p className="text-gray-600">We handle all technology activities, allowing you to focus on business growth</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3">
                    <div className="bg-purple-100 rounded-full p-2 mt-1">
                      <Globe className="w-4 h-4 text-purple-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-1">Multi-Channel Support</h4>
                      <p className="text-gray-600">Web support for multi-channel and multi-currency payments worldwide</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3">
                    <div className="bg-green-100 rounded-full p-2 mt-1">
                      <Zap className="w-4 h-4 text-green-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-1">Smart Algorithm</h4>
                      <p className="text-gray-600">Advanced channel routing to optimize transactions and avoid downtime</p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-6 mb-8">
                  <p className="text-gray-700 font-medium">
                    "Your business can be up and running with your own Payment brand.
                    Leverage our algorithm & channel routing to scale your business and secure merchant requirements."
                  </p>
                </div>


              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Trusted By Section */}
      <section className="py-6 bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-20">
          <div className="w-full h-full bg-gradient-to-br from-white/5 to-transparent"></div>
        </div>

        <div className="container mx-auto px-6 relative">
          <div className="max-w-5xl mx-auto text-center">
            {/* Icon with floating animation */}
            <div className="mb-4 relative">
              <div className="bg-gradient-to-r from-yellow-400 to-orange-500 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto shadow-xl transform hover:scale-110 transition-transform duration-300">
                <Award className="w-8 h-8 text-white" />
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-300 rounded-full animate-pulse"></div>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent leading-tight">
              TRUSTED BY LEADING
            </h2>
            <h2 className="text-2xl md:text-3xl font-bold mb-2 bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">
              AGGREGATORS WORLDWIDE
            </h2>

            {/* Floating elements */}
            <div className="absolute top-8 left-10 w-2 h-2 bg-blue-400 rounded-full animate-bounce"></div>
            <div className="absolute bottom-8 right-10 w-3 h-3 bg-purple-400 rounded-full animate-bounce delay-300"></div>
          </div>
        </div>
      </section>

      {/* Our Mantra Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white relative">
        <div className="container mx-auto px-6">
          {/* Header */}
         

        
          

          {/* Stats Section */}
          <div className="max-w-7xl mx-auto">
            <div className="relative py-15 px-5">
              {/* Floating background elements */}
              <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-10 left-20 w-32 h-32 bg-blue-500/10 rounded-full blur-xl animate-pulse"></div>
                <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-500/10 rounded-full blur-xl animate-pulse delay-1000"></div>
                <div className="absolute top-32 right-32 w-24 h-24 bg-indigo-500/10 rounded-full blur-xl animate-pulse delay-500"></div>
              </div>

              <div className="relative">
                {/* Header */}
                <div className="text-center mb-16">
                  <h2 className="text-5xl lg:text-6xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-purple-800 bg-clip-text text-transparent mb-4">
                    National Impact
                  </h2>
                  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    Empowering businesses nationwide with seamless payment solutions
                  </p>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
                  {/* Countries */}
                  <div className="text-center group cursor-pointer">
                    <div className="relative mb-6">
                      <div className="w-20 h-20 mx-auto bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg group-hover:shadow-blue-500/25 transition-all duration-500 group-hover:scale-110">
                        <Globe className="w-10 h-10 text-white" />
                      </div>
                      <div className="absolute -inset-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full opacity-0 group-hover:opacity-20 blur transition-opacity duration-500"></div>
                    </div>
                    <div className="space-y-2">
                      <div className="text-6xl lg:text-7xl font-black text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
                        3+
                      </div>
                      <div className="text-lg font-semibold text-gray-700 uppercase tracking-wide">
                        States
                      </div>
                      <div className="w-12 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full transform scale-0 group-hover:scale-100 transition-transform duration-300"></div>
                    </div>
                  </div>

                  {/* Transactions */}
                  <div className="text-center group cursor-pointer">
                    <div className="relative mb-6">
                      <div className="w-20 h-20 mx-auto bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center shadow-lg group-hover:shadow-green-500/25 transition-all duration-500 group-hover:scale-110">
                        <TrendingUp className="w-10 h-10 text-white" />
                      </div>
                      <div className="absolute -inset-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full opacity-0 group-hover:opacity-20 blur transition-opacity duration-500"></div>
                    </div>
                    <div className="space-y-2">
                      <div className="text-5xl lg:text-6xl font-black text-gray-900 group-hover:text-green-600 transition-colors duration-300">
                        10.6M+
                      </div>
                      <div className="text-lg font-semibold text-gray-700 uppercase tracking-wide">
                        Monthly Transactions
                      </div>
                      <div className="w-12 h-1 bg-gradient-to-r from-green-500 to-emerald-500 mx-auto rounded-full transform scale-0 group-hover:scale-100 transition-transform duration-300"></div>
                    </div>
                  </div>

                  {/* Merchants */}
                  <div className="text-center group cursor-pointer">
                    <div className="relative mb-6">
                      <div className="w-20 h-20 mx-auto bg-gradient-to-br from-purple-500 to-violet-600 rounded-full flex items-center justify-center shadow-lg group-hover:shadow-purple-500/25 transition-all duration-500 group-hover:scale-110">
                        <Users className="w-10 h-10 text-white" />
                      </div>
                      <div className="absolute -inset-2 bg-gradient-to-r from-purple-500 to-violet-500 rounded-full opacity-0 group-hover:opacity-20 blur transition-opacity duration-500"></div>
                    </div>
                    <div className="space-y-2">
                      <div className="text-5xl lg:text-6xl font-black text-gray-900 group-hover:text-purple-600 transition-colors duration-300">
                        30+
                      </div>
                      <div className="text-lg font-semibold text-gray-700 uppercase tracking-wide">
                        Merchants
                      </div>
                      <div className="w-12 h-1 bg-gradient-to-r from-purple-500 to-violet-500 mx-auto rounded-full transform scale-0 group-hover:scale-100 transition-transform duration-300"></div>
                    </div>
                  </div>

                  {/* Team Members */}
                  <div className="text-center group cursor-pointer">
                    <div className="relative mb-6">
                      <div className="w-20 h-20 mx-auto bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center shadow-lg group-hover:shadow-orange-500/25 transition-all duration-500 group-hover:scale-110">
                        <Award className="w-10 h-10 text-white" />
                      </div>
                      <div className="absolute -inset-2 bg-gradient-to-r from-orange-500 to-red-500 rounded-full opacity-0 group-hover:opacity-20 blur transition-opacity duration-500"></div>
                    </div>
                    <div className="space-y-2">
                      <div className="text-6xl lg:text-7xl font-black text-gray-900 group-hover:text-orange-600 transition-colors duration-300">
                        30+
                      </div>
                      <div className="text-lg font-semibold text-gray-700 uppercase tracking-wide">
                        Satisfied Clients
                      </div>
                      <div className="w-12 h-1 bg-gradient-to-r from-orange-500 to-red-500 mx-auto rounded-full transform scale-0 group-hover:scale-100 transition-transform duration-300"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </section>   {/* Footer */}
      <Footer />
    </div>
  );
}
export default PaymentSolutionsLanding;